export default function toCDNImage(imageUrl: string, width: number = 500) {
  let newImageUrl = imageUrl.replace("https://api.admin.theassetmanager.co.uk/", "https://d2qk9p4i741zfu.cloudfront.net/");
  if (width) {
    newImageUrl = newImageUrl + `?width=${width}`;
  }
  return newImageUrl;
}